module.exports = __webpack_public_path__ + "img/33.114218a3.jpg";